import { initShippingModalFeature } from './setupShippingModal';

initShippingModalFeature();
